// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1BRGw","title":"Info_title__chebV","selects":"Info_selects__2oVOI","requiredAsterisk":"Info_requiredAsterisk__3vm3g"};